import { z } from 'zod';

import { handleSchema } from './blog-post-form-schema';

export const MAX_CATEGORY_POSITION = 10_000;

/** Position is typed as text so an emptied input is not coerced to 0. */
export const blogCategoryFormSchema = z.object({
  title: z
    .string()
    .trim()
    .min(1, { error: 'blog:validation.titleRequired' })
    .max(120, { error: 'blog:validation.categoryTitleLength' }),
  handle: handleSchema,
  description: z.string().trim().max(2000, { error: 'blog:validation.descriptionLength' }),
  position: z
    .string()
    .trim()
    .refine(
      (value) =>
        value === '' ||
        (/^\d+$/.test(value) && Number(value) >= 0 && Number(value) <= MAX_CATEGORY_POSITION),
      { error: 'blog:validation.position' },
    ),
});

export type BlogCategoryForm = z.infer<typeof blogCategoryFormSchema>;
